export default __webpack_public_path__ + "static/media/JournalVoucher2.00139f1a.svg";